var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { IsBoolean, IsDateString, IsEnum, IsOptional, IsString, Matches, } from 'class-validator';
import { BlackListType } from '../../../enums';
export class CreateBlackListDto {
}
__decorate([
    IsEnum(BlackListType),
    __metadata("design:type", String)
], CreateBlackListDto.prototype, "type", void 0);
__decorate([
    IsBoolean(),
    __metadata("design:type", Boolean)
], CreateBlackListDto.prototype, "isPublic", void 0);
__decorate([
    IsBoolean(),
    __metadata("design:type", Boolean)
], CreateBlackListDto.prototype, "isKioskRentRestricted", void 0);
__decorate([
    IsDateString(),
    Matches(/^\d{4}-\d{2}-\d{2}$/),
    IsOptional(),
    __metadata("design:type", Object)
], CreateBlackListDto.prototype, "birthDate", void 0);
__decorate([
    IsString(),
    IsOptional(),
    __metadata("design:type", Object)
], CreateBlackListDto.prototype, "driverLicenseNumber", void 0);
__decorate([
    IsString(),
    __metadata("design:type", String)
], CreateBlackListDto.prototype, "name", void 0);
__decorate([
    IsString(),
    IsOptional(),
    __metadata("design:type", Object)
], CreateBlackListDto.prototype, "phoneNumber1", void 0);
__decorate([
    IsString(),
    IsOptional(),
    __metadata("design:type", Object)
], CreateBlackListDto.prototype, "phoneNumber2", void 0);
__decorate([
    IsString(),
    IsOptional(),
    __metadata("design:type", Object)
], CreateBlackListDto.prototype, "address", void 0);
__decorate([
    IsString(),
    __metadata("design:type", String)
], CreateBlackListDto.prototype, "content", void 0);
